export const CATEGORIES_LIST = [
  { text: "Best Sellers", link: "/shop/products/?sort=trending-desc" },
  { text: "Tops", link: "/shop/products/?category=66" },
  { text: "Jeans", link: "/shop/products/?category=145" },
  { text: "Dresses", link: "/shop/products/?category=83" },
  { text: "Skirts", link: "/shop/products/?category=113" },
  { text: "Accessories", link: "/shop/products/?category=98" },
];
